import React, { useState } from 'react';

import { AiChat } from '../modules/ai';
import Chat from '../modules/chat';
import MartinChat from '../modules/martin';

const ChatContainer = () => {
  const [isTeamChatVisible, setIsTeamChatVisible] = useState(false);
  return (
    <>
      <MartinChat />
      <AiChat isTeamChatVisible={isTeamChatVisible} />
      <Chat setIsTeamChatVisible={setIsTeamChatVisible} />
    </>
  );
};

export default ChatContainer;
